import HttpService from './http-service';

abstract class HttpServiceLayout extends HttpService {
  public static readonly URL = '/layout';

  public static read(query?: any) {
    return HttpService.get(this.URL, query);
  }

  public static readOne(id: number) {
    return HttpService.get(`${this.URL}/${id}`);
  }

  public static update(layout: any) {
    return HttpService.put(this.URL, layout);
  }
}

export default HttpServiceLayout;
